import { render } from "./template.vue?vue&type=template&id=7938f0fb&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=7938f0fb&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7938f0fb"]])

export default __exports__